import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptLoaderService } from 'helpers/services/script-loader.service';
import { AuthenticationService } from 'pages/authentication/_services';
import { AlertService } from './_services/alert.service';
import { AlertComponent } from './_directives/alert.component';
import { LoginCustom } from './_helpers/login-custom';
import { GeneralHelper } from 'helpers/general.helper';
import { MainAlertService } from 'helpers/services/main-alert.service';
import { HttpClient } from '@angular/common/http';
import { Helpers } from 'helpers';

declare let swal: any;
declare let $ :any;

@Component({
  selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
  templateUrl: './templates/login-1.component.html',
  encapsulation: ViewEncapsulation.None,
})

export class AuthComponent implements OnInit {
  model: any = {};
  submitForm: boolean = false;
  loading = false;
  returnUrl: string;
  isLogin: boolean = false;

  @ViewChild('alertSignin',
      {read: ViewContainerRef}) alertSignin: ViewContainerRef;
  @ViewChild('alertSignup',
      {read: ViewContainerRef}) alertSignup: ViewContainerRef;
  @ViewChild('alertForgotPass',
      {read: ViewContainerRef}) alertForgotPass: ViewContainerRef;

  constructor(
      private _router: Router,
      private _script: ScriptLoaderService,
      private _route: ActivatedRoute,
      private _authService: AuthenticationService,
      private _alertService: AlertService,
      private cfr: ComponentFactoryResolver,
      private mainAlertService: MainAlertService,
      private _http: HttpClient
  ) {
  }

  ngOnInit() {
    $('.modal-backdrop').hide();
    this.model.remember = true;
    this.getRememberModel();
    // get return url from route parameters or default to '/'
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
    this._router.navigate([this.returnUrl]);

    this._script.loadScripts('body', [
      'assets/vendors/base/vendors.bundle.js',
      'assets/demo/default/base/scripts.bundle.js'], true).then(() => {
      LoginCustom.init();
      Helpers.setLoading(false);
    });
  }

  getRememberModel() {
    let loginModel = localStorage.getItem('remember');
    if (loginModel) this.model = JSON.parse(loginModel);
  }

  rememberModel() {
    if (this.model.remember) {
      localStorage.setItem('remember', JSON.stringify(this.model));
    } else {
      localStorage.removeItem('remember');
    }
  }

  signin() {
    this.loading = true;
    this.submitForm = true;
    this._authService.login(this.model.email, this.model.password).then((response) => {
      this.rememberModel();
      this.submitForm = false;
      this.loading = false;
      if (response.scope.indexOf('parking-usage-dashboard-read') != -1) {
        this._router.navigate(['/index']);
      } else if (response.scope.indexOf('parking-member-read') != -1) {
        this._router.navigate(['/manage/park/member']);
      } else {
        this._router.navigate(['/manage/park/virtual-card']);
      }
    }).catch((error) => {
      this.submitForm = false;
      this.showAlert('alertSignin');
      if (error.status === 400) {
        this._alertService.error('อีเมลหรือ รหัสผ่านไม่ถูกต้อง');
      } else {
        this._alertService.error(GeneralHelper.extractErrorMessage(error));
      }
      this.loading = false;
    });
  }

  forgotPass() {
    this.loading = true;
    this._authService.passwordRecovery(this.model.email).subscribe(
        data => {
          this.mainAlertService.generateAlert('success', data.message, {timer: 2000});
          this.loading = false;
        },
        error => {
          this.showAlert('alertForgotPass');
          this._alertService.error(GeneralHelper.extractErrorMessage(error));
          this.loading = false;
        });
  }

  showAlert(target) {
    this[target].clear();
    let factory = this.cfr.resolveComponentFactory(AlertComponent);
    let ref = this[target].createComponent(factory);
    ref.changeDetectorRef.detectChanges();
  }

  clearError() {
    this._alertService.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/authentication/auth.component.ts